import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { toast } from 'react-toastify'

import * as archivoService from '../../servicios/archivoAdjuntoService'
import styles from './Upload.module.css'

export const SubirArchivo = ({ idUsuario, accept, idTipo, idDoc, onCarga }) => {
  const [archivoCargado, setArchivoCargado] = useState(null)
  const [subiendo, setSubiendo] = useState(false)

  const upload = async (archivo) => {
    try {
      setSubiendo(true)
      const formData = new FormData()
      formData.append('nombre', archivo.name)
      formData.append('idUsuario', idUsuario)
      formData.append('archivo', archivo)
      formData.append('idTipo', idTipo)
      formData.append('idDoc', idDoc)
      formData.append('idPath', String(idDoc))

      const adjunto = await archivoService.subirArchivo(formData)
      setArchivoCargado(archivo.name)
      onCarga?.(adjunto)
    } catch (error) {
      toast.error(error.response?.data?.mensaje || 'Error al subir el archivo.')
    } finally {
      setSubiendo(false)
    }
  }

  const onDrop = (acceptedFiles) => {
    if (!acceptedFiles.length) {
      return
    }
    upload(acceptedFiles[0])
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    multiple: false
  })

  return (
    <div
      {...getRootProps()}
      className={`${styles.dropzone} ${isDragActive ? styles.dropzoneActive : ''}`}
    >
      <input {...getInputProps()} />
      <i className="fa fa-file-upload fa-3x" />
      <p className={styles.fileName}>
        {archivoCargado
          ? `Archivo cargado: ${archivoCargado}`
          : subiendo
            ? 'Subiendo archivo...'
            : 'Arrastrá o hacé clic para subir tu archivo'}
      </p>
      {!subiendo && (
        <p className={styles.hint}>
          Podés arrastrar el archivo o seleccionarlo desde tu computadora.
        </p>
      )}
    </div>
  )
}

SubirArchivo.propTypes = {
  idUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  accept: PropTypes.object,
  idTipo: PropTypes.string.isRequired,
  idDoc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCarga: PropTypes.func
}
